module.exports = __webpack_public_path__ + "assets/media/2.8c210c03.wav";